import React from 'react'
import { FaLongArrowAltRight } from "react-icons/fa";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { API } from '../../../Services/axios';
import { useState } from 'react';

const TerraceProduct = ({ quoteData }) => {
  // Récupérer les produits sélectionnés depuis Redux
  const selectedProducts = useSelector(state => state.selectedProducts.selectedProducts);
  const selectedProject = useSelector(state => state.selectedProject.selectedProject);
  const sectionNames = useSelector(state => state.selectedProducts.sectionNames);
  
  // Debug: Afficher la structure des données
  console.log('🔍 TerraceProduct - quoteData:', quoteData);
  console.log('🔍 TerraceProduct - quoteData.items:', quoteData?.items);
  console.log('🔍 TerraceProduct - quoteData.total_cost:', quoteData?.total_cost);
  console.log('🔍 TerraceProduct - selectedProducts:', selectedProducts);
  console.log('🔍 TerraceProduct - selectedProducts.length:', selectedProducts?.length);
  
  if (quoteData?.items) {
    console.log('🔍 Premier item détaillé:', quoteData.items[0]);
    console.log('🔍 Toutes les clés du premier item:', Object.keys(quoteData.items[0] || {}));
  }
  
  // Fonction pour récupérer le nom d'une section
  const getSectionName = (sectionId) => {
    console.log('🔍 Recherche du nom de section pour ID:', sectionId);
    console.log('🔍 sectionNames sauvegardés:', sectionNames);
    
    // Essayer d'abord avec les noms sauvegardés
    if (sectionNames && sectionNames[sectionId]) {
      console.log('🔍 Nom trouvé dans sectionNames:', sectionNames[sectionId]);
      return sectionNames[sectionId];
    }
    
    // Essayer avec le projet sélectionné
    if (selectedProject && selectedProject.steps) {
      for (const step of selectedProject.steps) {
        if (step.sections) {
          for (const section of step.sections) {
            if (section.id === sectionId) {
              console.log('🔍 Section correspondante trouvée dans selectedProject:', section.name);
              return section.name || `Section ${sectionId}`;
            }
          }
        }
      }
    }
    
    // Fallback: essayer de deviner le nom basé sur l'ID ou utiliser un nom générique
    const sectionNameMap = {
      '58aa0e88-2e28-49ce-9e4e-4fc6a11c2547': 'Taille de votre terrasse',
      '56d97c9b-4161-4364-b7d0-74d2f5ec6d7f': 'VOTRE KIT TERRASSE RULLIER SUR MESURE',
      'surface': 'Surface',
      'dimension': 'Dimensions',
      'input': 'Information'
    };
    
    if (sectionNameMap[sectionId]) {
      console.log('🔍 Nom trouvé dans sectionNameMap:', sectionNameMap[sectionId]);
      return sectionNameMap[sectionId];
    }
    
    console.log('🔍 Aucun nom trouvé, utilisation de l\'ID:', sectionId);
    return `Section ${sectionId}`;
  };

  // Fonction pour récupérer les détails du produit
  const getProductDetails = (item) => {
    // Si c'est un selectedProduct, utiliser directement ses propriétés
    if (item.name && item.price !== undefined) {
      return {
        name: item.name,
        image: item.image || "/assets/images/lalliard-lame-terrasse-focus_pin_du_nord_marron.png",
        price: item.price,
        quantity: item.quantity || 0
      };
    }
    
    // Si l'item vient de quoteData.items (format de l'erreur connue)
    if (item.product_name || item.product_image !== undefined) {
      return {
        name: item.product_name || item.name || 'Produit sans nom',
        image: item.product_image || item.image || "/assets/images/lalliard-lame-terrasse-focus_pin_du_nord_marron.png",
        price: item.product_price !== undefined ? item.product_price : (item.price || 0),
        quantity: item.quantity || 0
      };
    }
    
    // Sinon, chercher dans selectedProducts
    const product = selectedProducts.find(p => 
      p.contentProductId === item.content_product || 
      p.contentProductId === item.contentProductId
    );
    
    if (product) {
      return {
        name: product.name,
        image: product.image,
        price: product.price,
        quantity: product.quantity
      };
    }
    
    // Fallback vers les données de l'item API
    return {
      name: item.product_name || item.name || 'Produit sans nom',
      image: item.product_image || item.image || "/assets/images/lalliard-lame-terrasse-focus_pin_du_nord_marron.png",
      price: item.product_price !== undefined ? item.product_price : (item.price || 0),
      quantity: item.quantity || 0
    };
  };

  // Utiliser selectedProducts si disponible, sinon utiliser quoteData.items
  const itemsToDisplay = selectedProducts && selectedProducts.length > 0 ? selectedProducts : (quoteData?.items || []);
  
  console.log('🔍 Items à afficher:', itemsToDisplay);
  console.log('🔍 Source des données:', selectedProducts && selectedProducts.length > 0 ? 'selectedProducts' : 'quoteData.items');
  
  // Grouper les items par section
  const groupedItems = itemsToDisplay.reduce((acc, item) => {
    console.log('🔍 Item structure:', item);
    
    // Pour selectedProducts, utiliser les propriétés directes
    // Pour quoteData.items, utiliser les propriétés de l'API ou les propriétés formatées
    const sectionId = item.section || item.section_id;
    // Utiliser section_name si disponible (format de l'erreur connue), sinon résoudre le nom
    const sectionName = item.section_name || getSectionName(sectionId);
    console.log('🔍 Section name résolu:', sectionName, '(sectionId:', sectionId, ')');
    
    if (!acc[sectionName]) {
      acc[sectionName] = [];
    }
    acc[sectionName].push(item);
    return acc;
  }, {});

  const getSectionNameForQuotes = (sectionId) => {
    API.get(`/project/section/${sectionId}/`)
      .then(response => {
        console.log('🔍 Nom de la section récupéré depuis l\'API:', response.data.name);
        return response.data.name;
      })
      .catch(error => {
        console.error('Erreur lors de la récupération du nom de la section :', error);
        return `Section ${sectionId}`;
      });
  };

  return (
    <div>
      <div className="page">
        <div className="container">
          <div className="row px-5">
            <div className="col-md-5 col-sm-5 col-12 px-0">
              <div className="image-terrasse" style={{ height: 380 }}>
                <img
                  src="/assets/images/Capture_terrace.jpg.png"
                  alt=""
                  className="w-100 h-100"
                />
              </div>
            </div>
            <div className="col-md-7 col-sm-7 col-12 px-0">
              {/* Affichage des données du devis si disponibles */}
              {quoteData && quoteData.items && quoteData.items.length > 0 ? (
                <div>
                  {Object.entries(groupedItems).map(([sectionName, items]) => (
                    <div key={sectionName}>
                      <div className="kit-band py-2 ps-5">
                        <span className="text-2">
                          {sectionName}
                          {getSectionNameForQuotes(sectionName)}
                        </span>
                      </div>
                      {items.map((item, index) => {
                        const productDetails = getProductDetails(item);
                        console.log('🔍 Product details for item:', item, '→', productDetails);
                        
                        return (
                          <div key={index} className="d-flex pe-2 py-4 content">
                            <div className="ps-4">
                              <div className="card">
                                <img
                                  src={productDetails.image}
                                  alt={productDetails.name}
                                  className="w-100 h-100"
                                  onError={(e) => {
                                    e.target.src = "/assets/images/lalliard-lame-terrasse-focus_pin_du_nord_marron.png";
                                  }}
                                />
                              </div>
                            </div>
                            <div className="ps-3">
                              <div className="mb-3">
                                <span className="text-2">
                                  {productDetails.name}
                                </span>
                              </div>
                              <span className="text-4">
                                Prix unitaire: {productDetails.price ? productDetails.price.toFixed(2) : 'N/A'} €
                                <br />
                                Quantité: {productDetails.quantity || 'N/A'}
                                <br />
                                Prix total: {productDetails.price && productDetails.quantity ? (productDetails.price * productDetails.quantity).toFixed(2) : 'N/A'} €
                              </span>
                            </div>
                            <div className="ms-3">
                              <span style={{ color: "#B39C81", fontWeight: "bold" }}>
                                {productDetails.price && productDetails.quantity ? (productDetails.price * productDetails.quantity).toFixed(2) : 'N/A'} €
                              </span>
                              <br />
                              <span style={{ color: "#B39C81", fontWeight: "bold" }}>
                                {productDetails.quantity || 'N/A'} unité(s)
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ))}
                  
                  {/* Total du devis */}
                  <div className="kit-band d-flex py-2 ps-5 pe-4 justify-content-between">
                    <div>
                      <span className="text-2">TOTAL DE VOTRE DEVIS : </span>
                    </div>
                    <div>
                      <span className="text-3-price" style={{ color: "black" }}>
                        {(() => {
                          // Calculer le total à partir des produits affichés
                          const calculatedTotal = itemsToDisplay.reduce((total, item) => {
                            const productDetails = getProductDetails(item);
                            return total + (productDetails.price * productDetails.quantity);
                          }, 0);
                          
                          // Utiliser le total calculé ou celui de quoteData (peut être 0)
                          const totalToShow = calculatedTotal > 0 ? calculatedTotal : (quoteData?.total_cost !== undefined ? quoteData.total_cost : 0);
                          return totalToShow.toFixed(2);
                        })()} € TTC
                      </span>
                    </div>
                  </div>
                  
                  {/* Message de succès */}
                  <div className="ps-5 pe-4 py-4 content">
                    <span className="text-4">
                      Votre devis a été soumis avec succès ! Vous recevrez un email avec les détails complets.
                    </span>
                  </div>
                  <div className="ps-5 pe-4 py-4 content">
                    <span className="text-4">
                      Infobulle «&nbsp; vous avez des questions avant de finaliser votre
                      commande, sauvegardez votre devis et un conseiller Rullier Bois vous
                      rappellera pour répondre à vos questions.
                    </span>
                  </div>
                  <div className="kit-band-devis py-2 px-5">
                    <img src="/assets/images/Group 21.png" alt="" />
                    <span className="text-3 ms-2">Télécharger mon devis</span>
                  </div>
                  <div className="d-flex">
                    <div className="mt-3">
                      <div className="btn btn-secondary mb-3 rounded-0">
                        <span className="">Accéder aux conseils de pose</span>
                      </div>
                      <div className="d-flex">
                        <div className="systeme-fixation me-2">
                          <span className="text-2"><Link to='#'><FaLongArrowAltLeft /> Modifier mon devis</Link></span>
                        </div>
                        <div className="btn btn-secondary box-green mb-3 rounded-0 w-50">
                          <span className="text-2" ><Link to='#'> Je commande ma terrasse  <FaLongArrowAltRight /></Link></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                // Affichage par défaut si pas de données de devis
                <div>
                  <div className="kit-band py-2 ps-5">
                    <span className="text-2">BOIS DE NOUVELLE AQUITAINE</span>
                  </div>
                  {/* content */}
                  <div className="d-flex pe-2 py-4 content">
                    <div className="ps-4">
                      <div className="card">
                        <img
                          src="/assets/images/lalliard-lame-terrasse-focus_pin_du_nord_marron.png"
                          alt=""
                          className="w-100 h-100"
                        />
                      </div>
                    </div>
                    <div className="ps-3">
                      <div className="mb-3">
                        <span className="text-2">
                          LAME DE TERRASSE LISSE PIN CLASSE 4 CHOIX US MARRON 26X145
                        </span>
                      </div>
                      <span className="text-4">
                        Lame Terrasse - Pin Sylvestre VERT
                        <br />
                        Traité autoclave classe 4<br />
                        Section : Ep.27 x l.145 mm
                        <br />
                        Longueur : comprise entre 2,40 m et 6,00 m<br />
                        Profil : lisse ou strié
                        <br />
                        Prix détaillés :<br />
                        Qualité AB - Prix Promotionnel : 19.90€ ht/m² au lieu de 23.75 €
                        ht/m²
                        <br />
                        Qualité US (petits noeuds) - Prix : 29.75€ ht/m²
                        <br />
                        Existe aussi en BRUN
                        <br />
                      </span>
                    </div>
                    <div className="ms-3">
                      <span style={{ color: "#B39C81", fontWeight: "bold" }}>
                        20,39 € / m2
                      </span>
                      <span style={{ color: "#B39C81", fontWeight: "bold" }}>100 m2</span>
                    </div>
                  </div>
                  <div className="kit-band py-2 ps-5">
                    <span className="text-2">STRUCTURE ET FIXATIONS</span>
                  </div>
                  {/* content */}
                  <div className="content">
                    <div className="d-flex pe-2 pt-4">
                      <div className="ima ps-4">
                        <div className="card">
                          <img
                            src="/assets/images/Screenshot 2023-12-16 at 18.14.52.png"
                            alt=""
                            className="w-100 h-100"
                          />
                        </div>
                      </div>
                      <div className="ps-3">
                        <div className="mb-3">
                          <span className="text-2">
                            Lambourde Pin Sylvestre - Traité classe 4
                          </span>
                        </div>
                        <span className="text-4">
                          Lambourde Pin Sylvestre
                          <br />
                          Sections : 46 x 72 mm
                          <br />
                          Traité autoclave classe 4<br />
                          Longueurs entre 2.70m et 6.00m (selon stock)
                          <br />
                        </span>
                      </div>
                      <div className="ms-5">
                        <span className="text-4" style={{ color: "black" }}>
                          375 Mètre(s)
                        </span>
                      </div>
                    </div>
                    <div className="container" style={{ color: "#D4D4D4" }}>
                      <hr />
                    </div>
                    <div className="d-flex pe-2 pt-4">
                      <div className="ima ps-4">
                        <div className="card">
                          <img
                            src="/assets/images/Screenshot 2023-12-16 at 18.19.17 Copy.png"
                            alt=""
                            className="w-100 h-100"
                          />
                        </div>
                      </div>
                      <div className="ps-3">
                        <div className="mb-3">
                          <span className="text-2">
                            Vis Terrasse Acton inox A2 5x60 BTE200
                          </span>
                        </div>
                        <span className="text-4">
                          Vis Acton inox A2 - 5x60
                          <br />
                          Spéciale terrasse bois
                        </span>
                      </div>
                      <div className="ms-5">
                        <span className="text-4" style={{ color: "black" }}>
                          27 Unité(s)
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="kit-band py-2 ps-5">
                    <span className="text-2">ACCESSOIRES</span>
                  </div>
                  {/* content */}
                  <div className="content">
                    <div className="d-flex pe-2 py-4">
                      <div className="ima ps-4">
                        <div className="card">
                          <img
                            src="/assets/images/Screenshot 2023-12-16 at 18.51.48 (1).png"
                            alt=""
                            className="w-100 h-100"
                          />
                        </div>
                      </div>
                      <div className="ps-3">
                        <div className="mb-3">
                          <span className="text-2">
                            Bande Bitumeuse pour Lambourdes 20 ml - Növlek
                          </span>
                        </div>
                        <span className="text-4">
                          Bande de protection bitumineuse pour lambourdes - 20ML
                          <br />
                          Marque : NOVLEK
                          <br />
                          Conditionnement : Rouleau de 5m²
                          <br />
                          Matériau : Bitume élastomère Polyester
                          <br />
                          Couleur : Gris
                          <br />
                          Dimension : 80mm x 20m
                          <br />
                          Épaisseur : 2.4mm
                          <br />
                          EAN : 5425 03355 205 3<br />
                          Ref : BITU-08020-01
                          <br />
                        </span>
                      </div>
                      <div className="ms-5">
                        <span className="text-4" style={{ color: "black" }}>
                          19 Unité(s)
                        </span>
                      </div>
                    </div>
                    <div className="container" style={{ color: "#D4D4D4" }}>
                      <hr />
                    </div>
                    <div className="d-flex pe-2 py-4">
                      <div className="ima ps-4">
                        <div className="card">
                          <img
                            src="/assets/images/Screenshot 2023-12-16 at 18.52.27 Copy.png"
                            alt=""
                            className="w-100 h-100"
                          />
                        </div>
                      </div>
                      <div className="ps-3">
                        <div className="mb-3">
                          <span className="text-2">
                            Plot Réglable Terrasse Lambourde - 50/80 mm - Jouplast
                          </span>
                        </div>
                        <span className="text-4">
                          Plots réglables en hauteur pour lambourdes
                          <br />
                          50/80 mm
                          <br />
                          Conditionnement 60 pièces
                          <br />
                          Marque : Jouplast Essentiel
                          <br />
                          Existe aussi en : 20/30 - 40/60 - 80/140 - 140/230 mm
                          <br />
                        </span>
                      </div>
                      <div className="ms-5">
                        <span className="text-4" style={{ color: "black" }}>
                          10 Unité(s)
                        </span>
                      </div>
                    </div>
                    <div className="container" style={{ color: "#D4D4D4" }}>
                      <hr />
                    </div>
                    <div className="d-flex pe-2 py-4">
                      <div className="ima ps-4">
                        <div className="card">
                          <img
                            src="/assets/images/Screenshot 2023-12-16 at 19.42.41 Copy.png"
                            alt=""
                            className="w-100 h-100"
                          />
                        </div>
                      </div>
                      <div className="ps-3">
                        <div className="mb-3">
                          <span className="text-2">Espaceurs Lame - Spax</span>
                        </div>
                        <span className="text-4">
                          Espaceurs de la lame
                          <br />
                          Marque : SPAX
                          <br />
                          - 4/5/6/7 mm
                          <br />
                          Conditionnement : Boite de 12 pcs
                          <br />
                        </span>
                      </div>
                      <div className="ms-5">
                        <span className="text-4" style={{ color: "black" }}>
                          1 Unité(s)
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="kit-band d-flex py-2 ps-5 pe-4 justify-content-between">
                    <div>
                      <span className="text-2">TOTAL DE VOTRE DEVIS : </span>
                    </div>
                    <div>
                      <span className="text-3-price" style={{ color: "black" }}>
                        7 929,36 € TTC{" "}
                      </span>
                    </div>
                  </div>
                  {/* content */}
                  <div className="ps-5 pe-4 py-4 content">
                    <span className="text-4">
                      Infobulle «&nbsp; vous avez des questions avant de finaliser votre
                      commande, sauvegardez votre devis et un conseiller Rullier Bois vous
                      rappellera pour répondre à vos questions.
                    </span>
                  </div>
                  <div className="kit-band-devis py-2 px-5">
                    <img src="/assets/images/Group 21.png" alt="" />
                    <span className="text-3 ms-2">Télécharger mon devis</span>
                  </div>
                  <div className="d-flex">
                    <div className="mt-3">
                      <div className="btn btn-secondary mb-3 rounded-0">
                        <span className="">Accéder aux conseils de pose</span>
                      </div>
                      <div className="d-flex">
                        <div className="systeme-fixation me-2">
                          <span className="text-2"><Link to='#'><FaLongArrowAltLeft /> Modifier mon devis</Link></span>
                        </div>
                        <div className="btn btn-secondary box-green mb-3 rounded-0 w-50">
                          <span className="text-2" ><Link to='#'> Je commande ma terrasse  <FaLongArrowAltRight /></Link></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TerraceProduct